var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconResize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconResize"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1342",
    cx: 10.8001,
    cy: 1.2,
    r: 1.2,
    fill: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1343",
    cx: 10.8001,
    cy: 5.9998,
    r: 1.2,
    fill: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1346",
    cx: 6.00005,
    cy: 5.9998,
    r: 1.2,
    fill: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1344",
    cx: 10.8001,
    cy: 10.7996,
    r: 1.2,
    fill: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1347",
    cx: 6.00005,
    cy: 10.7996,
    r: 1.2,
    fill: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1350",
    cx: 1.2,
    cy: 10.7996,
    r: 1.2,
    fill: "#0C0C0E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResize);
export default __webpack_public_path__ + "static/media/IconResize.05bcaa1fdeb08f393eb754761e1c7148.svg";
export { ForwardRef as ReactComponent };